/**
 * API back-office : Boîte à suggestions étudiants.
 * Lecture/modération réservée admin/super_admin/directeur.
 */
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHeaders } from './baseApi';

export interface SuggestionItem {
  id: number;
  matricule_etudiant: string | null;
  anonyme: boolean;
  nom_etudiant: string;
  prenoms_etudiant: string;
  classe_etudiant: string;
  pole: string;
  categorie: string;
  categorie_label: string;
  titre: string;
  contenu: string;
  cible_formateur_nom: string;
  cible_matiere: string;
  statut: 'nouvelle' | 'lue' | 'traitee' | 'archivee';
  statut_label: string;
  note_admin: string;
  traitee_par_nom: string;
  date_traitement: string | null;
  date_creation: string;
}

export interface SuggestionsListResponse {
  results: SuggestionItem[];
  total: number;
  kpis: {
    nouvelles: number;
    lues: number;
    traitees: number;
    archivees: number;
    total_global: number;
  };
}

export const suggestionsApi = createApi({
  reducerPath: 'suggestionsApi',
  baseQuery: baseQueryWithHeaders,
  tagTypes: ['Suggestions'],
  endpoints: (builder) => ({
    listerSuggestions: builder.query<SuggestionsListResponse, {
      statut?: 'nouvelle' | 'lue' | 'traitee' | 'archivee' | 'toutes';
      categorie?: string;
      pole?: string;
      anonyme?: 'true' | 'false';
    } | void>({
      query: (params) => ({
        url: '/portail-formateur/admin/suggestions/',
        params: params ?? undefined,
      }),
      providesTags: ['Suggestions'],
    }),

    traiterSuggestion: builder.mutation<{ success: boolean; statut: string }, {
      id: number;
      statut?: 'nouvelle' | 'lue' | 'traitee' | 'archivee';
      note_admin?: string;
    }>({
      query: ({ id, ...body }) => ({
        url: `/portail-formateur/admin/suggestions/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Suggestions'],
    }),
  }),
});

export const {
  useListerSuggestionsQuery,
  useTraiterSuggestionMutation,
} = suggestionsApi;
